import {DraggableWorkLogSuggestion} from './types';

const TIMETRACKER_FAVORITES = 'work-log-favorites';

export const getStoredFavorites = (): DraggableWorkLogSuggestion[] => {
  const storedFavorites = localStorage.getItem(TIMETRACKER_FAVORITES);
  return storedFavorites ? JSON.parse(storedFavorites) : [];
};

export const setStoredFavorites = (
  favorites: DraggableWorkLogSuggestion[]
): void =>
  localStorage.setItem(TIMETRACKER_FAVORITES, JSON.stringify(favorites));
